module.exports = __webpack_public_path__ + "img/94.17bd72ba.jpg";